'use strict';
angular.module('reporting.dashboards')
    .service('reportService', ['$http', 'rsEnvironment', '$log', '$q',
    function ($http, rsEnvironment, $log, $q) {
        return {
            getReport: function (surveyId, containerId) {
                if (_.isEmpty(surveyId)) {
                    return $q.reject(new Error('Missing surveyId for getReport'));
                }
                if (!containerId) {
                    return $q.reject(new Error('Missing containerId for getReport'));
                }
                var url = '/results/public/reports/' + surveyId + '/' + containerId;
                if (window.userLang) {
                    url += '?lang=' + window.userLang;
                }
                return $http.get(url)
                    .then(function (result) {
                    if (!result.data) {
                        throw new Error('Missing response from getReport call');
                    }
                    if (!result.data.container) {
                        throw new Error('Missing container from getReport call');
                    }
                    return result.data;
                })
                    .catch(function () {
                    throw new Error('Error getting response from getReport call');
                });
            }
        };
    }
]);
